export default function PetsnapLogo({ className = "w-9 h-9", body = "#E76F51", face = "#FDFBF7" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      className={className}
      aria-label="Petsnap logo"
    >
      {/* Top flash / viewfinder */}
      <rect x="22" y="8" width="20" height="10" rx="3" fill={body} />
      {/* Camera body */}
      <rect x="3" y="16" width="58" height="44" rx="11" fill={body} />
      {/* Shutter dot */}
      <circle cx="52" cy="24" r="2.5" fill={face} opacity="0.85" />
      {/* Lens face */}
      <circle cx="32" cy="40" r="15" fill={face} />
      {/* Paw print inside the lens */}
      <ellipse cx="25" cy="35.5" rx="2.4" ry="3.1" fill={body} />
      <ellipse cx="32" cy="33.5" rx="2.4" ry="3.1" fill={body} />
      <ellipse cx="39" cy="35.5" rx="2.4" ry="3.1" fill={body} />
      <ellipse cx="42.5" cy="41" rx="1.9" ry="2.6" fill={body} />
      <ellipse cx="21.5" cy="41" rx="1.9" ry="2.6" fill={body} />
      <ellipse cx="32" cy="45.5" rx="6.5" ry="5.2" fill={body} />
    </svg>
  );
}
